import Axios from "API/Axios";
import { AxiosMethodEnum } from "API/Axios";
import { Axios_Route } from "API/AxiosRouts";
import React, { useEffect, useState } from "react";

interface Props {
  Component: any;
}

const RegionSort: React.FC<Props> = ({ Component }) => {
  const [regionlist, setRegionlist] = useState<any>([]);
  const [showData, setShowData] = useState<boolean>(true);

  useEffect(() => {
    Axios(AxiosMethodEnum.get,Axios_Route.REGION_LIST).then(({ response, success }) => {
      if (success) {
        setRegionlist(response);
      }
    });
  }, []);

  const reSort = () => {
    setShowData(false);
    Axios(AxiosMethodEnum.get,Axios_Route.REGION_LIST).then(({ response, success }) => {
      if (success) {
        setRegionlist(response);
        setShowData(true);
      }
    });
  };

  return (
    <div>
      <Component regionlist={regionlist} reSort={reSort} showData={showData} />
    </div>
  );
};

export default RegionSort;
